.formFieldGroup {
    display: flex;
    margin: 0px;
}

.formFieldContainer {
    flex: 1;
    margin: 0px 10px 10px 10px;
}

.fileSelectionContainer {
    margin-left: 10px;
}

.contentContainer {
    padding: 20px 0;
}

.submitButton {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 20px;
}